import styled from 'styled-components'

const ICON_INFO_SIZE = '12px'

export const InfoButton = styled.button<{
  context: string
  hideOnDesktop?: boolean
}>`
  padding: 0;
  border-radius: 100px;
  width: calc(1.8 * ${ICON_INFO_SIZE});
  height: calc(1.8 * ${ICON_INFO_SIZE});
  background-color: #ffffff;
  border: 1px solid #1d1d1b;
  ${(props) =>
    props.context !== 'Card' &&
    `margin-left: 10px;
    transform: translateY(-2px);
    display: inline-flex;`}
  ${(props) =>
    props.context === 'Card' &&
    `position: absolute;
    right: 4px;
    top: 4px;
    -webkit-transition: all 0.1s;
    transition: all 0.1s; 
    display: flex;
    `}
  justify-content: center;
  align-items: center;

  @media (min-width: 1200px) {
    ${(props) => props.hideOnDesktop && 'display: none;'}
  }

  @media (hover: hover) {
    &:hover {
      border-width: 2px;
      ${(props) =>
        props.context === 'Card' &&
        `width: calc(2 * ${ICON_INFO_SIZE});
        height: calc(2 * ${ICON_INFO_SIZE});`}
    }
  }

  i {
    color: #1d1d1b;
    font-size: ${ICON_INFO_SIZE};
  }
`
